export const erSourcesListConstant = [
  "Ads - Facebook",
  "Ads - Instagram",
  "Ads - Youtube",
  "Inbound - Pamphleting",
  "Inbound - Posters",
  "Referral",
  "Agent Influencer",
  "Field Recruitment (Door to Door)",
  "Field Recruitment (Event)",
  "WorkIndia",
  "Apna",
  "Job Hai",
  "Whatsapp Broadcast",
  'Vahaan',
  "Agency",
  "Maidwale",
  "Direct X",
  "Takswork",
  "TaskForce",
  "Potential Lead",
  "Agent - Sujata",
  "Others",
];
